import { render, staticRenderFns } from "./SingleComment.vue?vue&type=template&id=1a420dcf&"
import script from "./SingleComment.vue?vue&type=script&lang=js&"
export * from "./SingleComment.vue?vue&type=script&lang=js&"
import style0 from "./SingleComment.vue?vue&type=style&index=0&id=1a420dcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports